"use strict";

const menuToggle = document.querySelector('.menu-toggle');


menuToggle.addEventListener('click', menuOpen );

function menuOpen(){
    document.body.classList.toggle("menu--open");
}



import $ from 'jquery';
import ScrollReveal from 'scrollreveal';
var siHome = document.querySelector('#homepage');

if(siHome) {





    if (window.matchMedia("(min-width: 900px)").matches) {
        $(function() {
        var curPage = 1;
        var numOfPages = $(".page").length;
        var animTime = 1000;
        var scrolling = false;
        var pgPrefix = ".page-";
        var homeHeight = $(".home").outerHeight(); // Hauteur de la section home
        var lastScrollTop = 0; // Sauvegarder la dernière position de scroll pour différencier scroll up et scroll down

        // Fonction pour activer la pagination
        function pagination() {
            scrolling = true;

            // Gérer l'activation et désactivation des pages
            $(pgPrefix + curPage).removeClass("inactive").addClass("active");
            $(pgPrefix + (curPage - 1)).addClass("inactive");
            $(pgPrefix + (curPage + 1)).removeClass("active");

            setTimeout(function() {
                scrolling = false;
            }, animTime);
        }

        // Fonction pour remonter dans les pages
        function navigateUp() {
            if (curPage === 1) {
                // Si on est à page-1 et qu'on remonte, retourner à la section home
                $("html, body").animate({ scrollTop: 0 }, animTime);
                return;
            }
            curPage--;
            pagination();
        }

        // Fonction pour descendre dans les pages
        function navigateDown() {
            if (curPage === numOfPages) return; // Ne pas dépasser le nombre de pages
            curPage++;
            pagination();
        }

        $(document).on("mousewheel DOMMouseScroll", function(e) {
            if (scrolling) return;

            var scrollTop = $(window).scrollTop();

            if (scrollTop < homeHeight) {
                // Si on est dans la section home, ne pas activer la pagination
                return;
            }

            if (curPage === 1 && scrollTop >= homeHeight) {
                // Si on quitte la section home et on est à la première page
                curPage = 1;
                pagination();
            }

            // Différencier le scroll vers le haut et vers le bas
            if (e.originalEvent.wheelDelta > 0 || e.originalEvent.detail < 0) {
                if (curPage > 1) { // Ne pas naviguer au-dessus de page-1
                    navigateUp();
                }
            } else {
                if (scrollTop >= homeHeight && curPage < numOfPages) { 
                    navigateDown();
                }
            }
        });

        // Gérer le scroll avec les flèches du clavier
        $(document).on("keydown", function(e) {
            if (scrolling) return;

            var scrollTop = $(window).scrollTop();

            if (scrollTop < homeHeight) {
                // Si on est dans la section home, ne pas activer la pagination
                return;
            }

            if (curPage === 1 && scrollTop >= homeHeight) {
                curPage = 1;
                pagination();
            }

            if (e.which === 38) { // Flèche vers le haut
                if (curPage > 1) {
                    navigateUp();
                }
            } else if (e.which === 40) { // Flèche vers le bas
                if (curPage < numOfPages) {
                    navigateDown();
                }
            }
        });
        });
    }





    //scroll reaval //////////////////////////////////:

    ScrollReveal().reveal('.page__img', { 
        // reset: true,
        distance: '80px',
        duration: 1500,
        delay: 200,
        origin: 'left'
    });





    
    //playlist : 

    const tracks = [
        {
            title: 'COPYCAT',
            file: 'assets/audio/copycat.mp3' 
        },
        { 
            title: 'bad guy', // bad guy
            file: 'assets/audio/badguy.mp3' 
        },
        { 
            title: 'therefore i am', //therfore i am
            file: 'assets/audio/therefore.mp3' 
        },
        { 
            title: 'BIRDS OF A FEATHER', //BIRDS OF A FEATHER
            file: 'assets/audio/birds.mp3' 
        },
        { 
            title: 'Six Feet Under', //Six Feet Under
            file: 'assets/audio/sixfeet.mp3' 
        }

    ];

    
    // Variables de gestion audio
    let audio = null;
    let playTimeout = null;
    
    // Fonction pour jouer une piste en fonction du fichier
    function playTrack(file) {
        if (audio) {
            audio.pause();
            audio.currentTime = 0;
            clearTimeout(playTimeout);
        }
        
        audio = new Audio(file);
        audio.play();
    
        // Optionnel : arrête la piste après 30 secondes
        playTimeout = setTimeout(() => {
            audio.pause();
        }, 60000);
    }
    
    // Sélectionne tous les boutons "Play" avec la classe `btn__play` et les associe à leurs indices dans `tracks`
    document.querySelectorAll('.btn__play').forEach((button, index) => {
        // Assigne un attribut `data-index` pour identifier l'index de la chanson
        button.dataset.index = index;
    
        // Ajoute l'écouteur de clic au bouton
        button.addEventListener('click', function() {
            const trackIndex = parseInt(this.dataset.index);
    
            // Vérifie que l'index est valide
            if (trackIndex >= 0 && trackIndex < tracks.length) {
                playTrack(tracks[trackIndex].file); // Joue la piste correspondante
            } else {
                console.log('Piste non trouvée pour cet index:', trackIndex);
            }
        });
    });
    
    // Bouton Pause : chaque bouton `.btn__pause` met le son en pause
    document.querySelectorAll('.btn__pause').forEach(pauseButton => {
        pauseButton.addEventListener('click', () => {
            if (audio) {
                audio.pause();
                clearTimeout(playTimeout);
            }
        });
    });
    


} // accolade du if sihome





var siBio = document.querySelector('#bio');
if (siBio) {

    function createTextSpans(text, containerSelector) {
        const words = text.split(' '); // Séparer le texte en mots
        const containerSlide = document.querySelector(containerSelector); // Sélectionner le conteneur
      
        words.forEach(word => {
          const span = document.createElement('span');
          span.textContent = word; 
          containerSlide.appendChild(span); 
      
          containerSlide.appendChild(document.createTextNode(' ')); // Ajouter un espace après chaque mot
        });
      }
      
      // Utilisation de la fonction pour chaque texte et conteneur
      createTextSpans(
        "Billie Eilish, née en 2001 à Los Angeles, est une chanteuse pop qui s’est fait connaître avec Ocean Eyes. Avec son style unique, elle a remporté plusieurs Grammy Awards et s’impose comme une figure majeure de la musique actuelle.",
        '#texthighlighting'
      );
      
      createTextSpans(
        "Billie Eilish se distingue par son style audacieux et son engagement. Elle aborde des thèmes importants comme la santé mentale et l’écologie, faisant d’elle une voix influente pour sa génération.",
        '#flyintxt'
      );
      





    function adjustStickyPosition() {
        var contentLeft = document.querySelector('#left-content');
        var height = contentLeft.clientHeight;
        var topOffset = 'calc(50% - ' + (height / 2) + 'px)';
        contentLeft.style.top = topOffset;
    }

    window.addEventListener('scroll', function() {
        const spans = document.querySelectorAll('.intro__txt span');
        const windowHeight = window.innerHeight;
        const content2Spans = document.querySelectorAll('.caract .caract__content span');

        let lines = [];
        let currentLine = -1;
        let lastTop = -1;
      
        spans.forEach((span, index) => {
          const spanRect = span.getBoundingClientRect();
          if (spanRect.top !== lastTop) {
            currentLine++;
            lines[currentLine] = [];
            lastTop = spanRect.top;
          }
          lines[currentLine].push(span);
        });

        lines.forEach(line => {
            const firstSpan = line[0];
            const firstSpanRect = firstSpan.getBoundingClientRect();
            const firstSpanCenterY = firstSpanRect.top + (firstSpanRect.height / 2);
        
            line.forEach((span, index) => {
                if (firstSpanCenterY <= windowHeight / 2) {
                    span.style.color = '#c2c2c2';
                } else {
                    span.style.color = '#393939';
                }
            });
        });


        content2Spans.forEach((span) => {
            const spanRect = span.getBoundingClientRect();
            const spanBottomY =  spanRect.bottom;
        
            if (spanBottomY <= windowHeight) {
              span.classList.add('v2');
            } else {
              span.classList.remove('v2');
            }
        });
    });

    //l'image split
    document.addEventListener('DOMContentLoaded', function () {
        const splitImageContainer = document.getElementById('splitImage');
        const content5 = document.querySelector('.pictures');
        const divTop = document.getElementById('divtop');
        const divBottom = document.getElementById('divbottom');

        function onScroll() {
            const containerRect = splitImageContainer.getBoundingClientRect();
            const content4Rect = content5.getBoundingClientRect();
            const viewportHeight = window.innerHeight;
        
            // Calculate scroll progress
            const scrollProgress = Math.min(Math.max((window.scrollY - content5.offsetTop) / (content5.offsetHeight - viewportHeight), 0), 1);
        
            // Update divTop and divBottom positions based on scroll progress
            const translateTopX = -scrollProgress * 100;
            const translateBottomX = -100 + (scrollProgress * 100);
        
            divTop.style.transform = `translateX(${translateTopX}vw)`;
            divBottom.style.transform = `translateX(${translateBottomX}vw)`;


            if (content4Rect.top <= 0 && content4Rect.bottom >= viewportHeight) {
                splitImageContainer.style.position = 'fixed';
                splitImageContainer.style.top = '0';
            } else if (content4Rect.bottom < viewportHeight) {
            splitImageContainer.style.position = 'absolute';
            splitImageContainer.style.top = (content5.offsetHeight - splitImageContainer.offsetHeight) + 'px';
            } else if (content4Rect.top > 0) {
            splitImageContainer.style.position = 'relative';
            splitImageContainer.style.top = '0';
            }
        }

        window.addEventListener('scroll', onScroll);
        // Initial call to set the correct position
        onScroll();

        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.1
        };

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                // console.log(entry.target);
              if (entry.isIntersecting) {
                entry.target.classList.add('visible');
              } else {
                entry.target.classList.remove('visible');
              }
            });
        }, options);
        
        document.querySelectorAll('.interview__content').forEach(flexbox => {
        observer.observe(flexbox);
        });        
    });

    function initialize () {
        adjustStickyPosition ();
    }
    
    window.onload = initialize;
    window.onresize = initialize;

    //la lige du temps

    document.addEventListener('scroll', function() {
        const screenHeight = window.innerHeight;
        const circles = document.querySelectorAll('circle');
        const texts = document.querySelectorAll('text');
        const lineActivated = document.getElementById('lineActivated');
      
        circles.forEach((circle, index) => {
          const circleTop = circle.getBoundingClientRect().top;
          const text = texts[index];
          if (circleTop <= screenHeight / 2) {
            circle.setAttribute('fill', '#08f02b');
            text.setAttribute('fill', '#08f02b');
          } else {
            circle.setAttribute('fill', '#333');
            text.setAttribute('fill', '#333');
          }
        });

        const circle1Top = document.getElementById('circle1').getBoundingClientRect().top;
        if (circle1Top < screenHeight / 2) {
          const position = 50 + (175 - 50) * ((screenHeight / 2 - circle1Top) / (175 - 50));
          lineActivated.setAttribute('y2', Math.min(300, Math.max(50, position)));
        } else {
          lineActivated.setAttribute('y2', 50);
        }
    });   
}